export default "__VITE_ASSET__3m0AGlQi__"